import API from "../base";

export const sendReminder = async (taskExecutionId: string): Promise<void> => {
  await API.post(`/integrations/calendly/${taskExecutionId}/sendReminder`);
};
